import React from 'react';
import { BoxIcon } from 'lucide-react';
export interface TimelineEvent {
  id: string;
  title: string;
  description?: string;
  date: string;
  icon: BoxIcon;
  color: 'blue' | 'green' | 'red' | 'yellow' | 'orange' | 'purple' | 'gray';
}
interface TimelineProps {
  events: TimelineEvent[];
  className?: string;
}
export function Timeline({
  events,
  className = ''
}: TimelineProps) {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue':
        return 'bg-blue-100 text-blue-600 ring-blue-50';
      case 'green':
        return 'bg-green-100 text-green-600 ring-green-50';
      case 'red':
        return 'bg-red-100 text-red-600 ring-red-50';
      case 'yellow':
        return 'bg-yellow-100 text-yellow-600 ring-yellow-50';
      case 'orange':
        return 'bg-orange-100 text-orange-600 ring-orange-50';
      case 'purple':
        return 'bg-purple-100 text-purple-600 ring-purple-50';
      default:
        return 'bg-slate-100 text-slate-600 ring-slate-50';
    }
  };
  return <div className={`flow-root ${className}`} data-id="element-537">
      <ul className="-mb-8" data-id="element-538">
        {events.map((event, eventIdx) => <li key={event.id} data-id="element-539">
            <div className="relative pb-8" data-id="element-540">
              {eventIdx !== events.length - 1 ? <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-slate-200" aria-hidden="true" data-id="element-541" /> : null}
              <div className="relative flex space-x-3" data-id="element-542">
                <div data-id="element-543">
                  <span className={`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white ${getColorClasses(event.color)}`} data-id="element-544">
                    <event.icon className="h-4 w-4" aria-hidden="true" data-id="element-545" />
                  </span>
                </div>
                <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" data-id="element-546">
                  <div data-id="element-547">
                    <p className="text-sm font-medium text-slate-900" data-id="element-548">
                      {event.title}
                    </p>
                    {event.description && <p className="text-xs text-slate-500 mt-0.5" data-id="element-549">
                        {event.description}
                      </p>}
                  </div>
                  <div className="text-right text-xs whitespace-nowrap text-slate-400" data-id="element-550">
                    <time dateTime={event.date} data-id="element-551">{event.date}</time>
                  </div>
                </div>
              </div>
            </div>
          </li>)}
      </ul>
    </div>;
}